export const EClientSubscription = {
    /**
     * 사용 가능한 상태 알림
     */
    Init: "init",
    /**
     * client 상태 변경
     */
    ChangeStatus: "change_status",
    /**
     * 토큰 만료
     */
    ExpiredToken: "expired_token",
};
//# sourceMappingURL=EClientSubscription.js.map